





















import Component from "vue-class-component";
import { GREEN } from "@/resources/constants/busyReasons";
import { MEETING_TYPE } from "@/resources/constants/meeting";
import { mixins } from "vue-class-component";
import Loader from "@/resources/mixins/loader/loader";
import feather from "feather-icons";
import ConnectToRoomCall from "../../../../resources/mixins/chime/connectToRoomCall";
@Component({
  name: "webinar-enter-component",
})
export default class CallComponent extends mixins(Loader, ConnectToRoomCall) {
  fromSpaceUser = null;
  name = "";
  audio = null;
  interval = null;
  mounted() {
    feather.replace();
    this.fromSpaceUser =
      this.$store.getters["MeetingStore/getShowCallFromSpaceUser"];
    this.name = this.fromSpaceUser.superSpaceUser.user.name;
    const preStatus = JSON.parse(localStorage.getItem("pre_status"));
    if (preStatus === null || (preStatus && preStatus.availableStatus === GREEN.type)) {
      this.audio = new Audio(require("@/assets/audio/alert-yellow.mp3"));
      this.interval = setInterval(() => {
        this.audio.play();
      }, 1000);
    }
  }
  destroyed() {
    const tooltip = document.getElementsByClassName("vs-tooltip");
    if (tooltip)
      while (tooltip.length > 0) {
        tooltip[0].parentNode.removeChild(tooltip[0]);
      }
    if(this.audio)
      this.audio.pause();
    clearInterval(this.interval);
  }
  get active() {
    return this.$store.getters["MeetingStore/getShowCallModal"];
  }
  set active(e) {
    this.$store.dispatch("MeetingStore/setShowCallModalAction", e);
  }
  onCancel() {
    const meeting = this.$store.getters["MeetingStore/getMeeting"];
    const attendee = this.$store.getters["MeetingStore/getAttendee"];
    this.$store.dispatch("UserStore/loadPreviousStatusAction", {
      store: this.$store,
      callback: (response) => {
        this.$store.dispatch("SpaceStore/updateUserInSpace", response.data);
      },
      callbackError: () => {
        // do nothing
      },
    });
    this.$store.dispatch("MeetingStore/closeMeetingOneToOneAction", {
      meetingId: meeting.MeetingId,
      attendee: attendee.AttendeeId,
      callback: (response) => {
        this.$store.dispatch("SidebarStore/setOpenCall", false);
        this.$store.dispatch("ChatStore/setMinimizeChatAction", false);
        setTimeout(() => {
          this.$store.dispatch("GraphicClientStore/resizeGraphicClientAction");
        }, 20);
      },
      callbackError: (error) => {
        console.log(error);
      },
    });
    this.active = false;
  }
  async acceptCall() {
    await this.$store.dispatch("SidebarStore/setOpenCall", true);
    await this.$store.dispatch(
      "ChatStore/setMinimizeChatAction",
      !this.$store?.getters["UserStore/getConfig"].chat.openRoomChatByDefault
    );
    setTimeout(() => {
      this.$store.dispatch("GraphicClientStore/resizeGraphicClientAction");
    }, 20);
    this.active = false;
  }
}
